import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../../utils/utils";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { OPLKPIManagementListComponent } from "./oplkpimanagement-list.component";
import { OPLMonthlyKPIManagementListComponent, SearchItem } from "./oplmonthlykpimanagement-list.component";
import { MatDialog } from "@angular/material/dialog";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { DialogService } from "../../../../services/dialog.service";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { CustomDialogService } from "../../../../services/customdialog.service";
import { ToastrService } from "ngx-toastr";
import { NotificationDialogComponent } from "../../shared-components/notification-dialog/notification-dialog.component";
import { MatTabGroup } from "@angular/material/tabs";

@Component({
    selector: "oplkpimanagement",
    templateUrl: './oplkpimanagement.component.html',
    styleUrls: ['../../../../style/container-tab-list.component.less', './oplkpimanagement.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class OPLKPIManagementComponent implements OnInit, OnDestroy {

    //@HostListener('keydown', ['$event'])

    @ViewChild('tabGroup') tabGroup!: MatTabGroup;
    @ViewChild(OPLKPIManagementListComponent) OPLKPIYearlyMmgmtList: OPLKPIManagementListComponent = {} as OPLKPIManagementListComponent;
    @ViewChild(OPLMonthlyKPIManagementListComponent) OPLKPIMonthlyMmgmtList: OPLMonthlyKPIManagementListComponent = {} as OPLMonthlyKPIManagementListComponent;
    isReleaseActive: boolean = false;
    releaseButtonText: string = 'Initiate Release';

    isRevokeActive: boolean = false;
    revokeButtonText: string = 'Initiate Revoke';

    isMonthlyReleaseActive: boolean = false;
    releaseMonthlyButtonText: string = 'Initiate Release';

    isMonthlyRevokeActive: boolean = false;
    revokeMonthlyButtonText: string = 'Initiate Revoke';


    title: string = '';
    waitHeader = '   -  **Please, wait until all breakdowns are properly loaded**';

    isEditModeEnabled = false;
    isExcelModeEnabled = false;
    isApprovalModeEnabled = false;
    isShowAllEnabled = true;

    subscriptionManagementId: any;
    subscriptionFiscalYear: any;
    subscriptions: any[] = [];

    list: KpiManagement[] = [];
    selectedTabIndex = 0;
    @ViewChild(OPLKPIManagementListComponent, { static: false }) listComponent!: OPLKPIManagementListComponent;
    @ViewChild(OPLMonthlyKPIManagementListComponent, { static: false }) MlistComponent!: OPLMonthlyKPIManagementListComponent;

    // Filter section
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    filter = ''
    isAllLoaded = false;
    filteredList: KpiManagement[] = [];

    yearlyColumnsToDisplay = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'YTDACT', 'PYBUD', 'FYFC', 'FY1BUD', 'FY2BUD', 'FY3BUD', 'actions']
    monthlyColumnsToDisplay = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'YTDACT', 'PYBUD', 'FY1BUD', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10', 'P11', 'P12', 'actions']

    showReleaseLabel = false;
    showPrereleaseLabel = false;

    constructor(
        public defaults: DefaultValuesService
        , private readonly http: HttpClient
        , private readonly dialogForm: MatDialog
        , private readonly dialog: DialogService
        , public router: Router
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly datePipe: DatePipe
        , private readonly customDialog: CustomDialogService
        , private readonly toastrService: ToastrService
        , private readonly changeDetector: ChangeDetectorRef

    ) {
        this.updateTitle();
        this.dialog.tthis = this
    }
    
    private updateTitle() {
        const branchReporting = this.isBranchReporting() ? 'Branch Reporting ' : '';
        this.title = `Operational planning / Budget ${branchReporting}(${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear})`;
    }


    ngOnInit() {

        this.dialog.resetState();
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { this.loadInformation(true) });
        this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() => {
            this.loadInformation(true);
        });
        if (this.defaults.managementids.length !== 0)
            this.loadInformation(true);
    }

    ngOnDestroy() {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionFiscalYear.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    ngAfterViewInit() {
        this.defaults.defaultComponentTab(this)
    }
    onClickExcelButton() {
        this.isExcelModeEnabled = true;
    }

    onClickCancelButton() {
        this.isEditModeEnabled = this.isExcelModeEnabled = false;
    }

    onClickEdit() {
        this.changeDetector.detectChanges();
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.listComponent?.updatedItems?.length > 0 || this.MlistComponent?.updatedItems?.length > 0) {
                this.loadInformation()
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    onClickShowAllButton() {
        if (this.isShowAllEnabled === false) {
            this.isShowAllEnabled = true
        }
        else {
            this.isShowAllEnabled = false
        }
    }

    onClickSave() {
        if (this.hasInvalidUnitsOrHours()) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Units and Hours values must be whole numbers.' } });
            return;
        }
        if (this.hasInvalidDecimalValues()) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect decimal value provided' } });
            return;
        }
        if (this.hasInvalidCurrencyValues()) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect currency value provided.' } });
            return;
        }
        // Runs even when updatedItems is empty: clearing a saved BUD value never reaches
        // updatedItems, but it still has to trigger the 3-year completeness modal
        if (!this.isBranchReporting()) {
            const incompleteRows = this.listComponent?.getIncompleteOplYearlyRows() ?? [];
            if (incompleteRows.length > 0) {
                this.dialogForm.open(NotificationDialogComponent, {
                    data: { type: 'error', message: `BUD, P1 and P2 must all be filled. Rows with previously saved values cannot be left empty. Check: ${incompleteRows.join(', ')}` },
                    width: '500px',
                    disableClose: true
                });
                return;
            }
        }
        if (this.listComponent?.updatedItems.length === 0 && this.MlistComponent?.updatedItems.length === 0) {
            this.isEditModeEnabled = false;
            return;
        }
        if (this.listComponent?.updatedItems.length > 0)
            this.saveYearlyItems();
        if (this.MlistComponent?.updatedItems.length > 0)
            this.saveMonthlyItems();
    }

    private hasInvalidUnitsOrHours(): boolean {
        const isInvalid = (x: any) =>
            (x.KpiUnit?.toUpperCase() === 'UNITS' || x.KpiUnit?.toUpperCase() === 'HOURS')
            && x.KpiValue != null && x.KpiValue !== '' && x.KpiValue !== 'NaN'
            && !x.KpiValue.includes('.00');
        return this.listComponent?.updatedItems.some(isInvalid) || this.MlistComponent?.updatedItems.some(isInvalid);
    }

    private hasInvalidDecimalValues(): boolean {
        const isInvalid = (x: any) =>
            x.KpiUnit?.toUpperCase() === 'DECIMAL'
            && !this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits);
        return this.listComponent?.updatedItems.some(isInvalid) || this.MlistComponent?.updatedItems.some(isInvalid);
    }

    private hasInvalidCurrencyValues(): boolean {
        const isInvalid = (x: any) =>
            (x.KpiUnit?.toUpperCase() === 'VALUES' || x.KpiUnit?.toUpperCase() === 'VALUE LC')
            && !this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits);
        return this.listComponent?.updatedItems.some(isInvalid) || this.MlistComponent?.updatedItems.some(isInvalid);
    }

    private saveYearlyItems() {
        const url = this.baseUrl + "api/KPIManagement/setopl/BUDY";
        this.http.post<any[]>(url, this.listComponent.updatedItems).subscribe({
            next: () => {
                this.loadInformation();
                this.isEditModeEnabled = false;
                this.toastrService.success('Kpi values were updated successfully!');
            },
            error: (error: any) => Utils.writeLog(this.http, this.baseUrl, error)
        });
    }

    private isMonthlyBudgetValid(): boolean {
        const lastItem = this.MlistComponent.updatedItems.at(-1);
        if (!lastItem) return true;
        const fy1budStr = (lastItem.FY1BUD !== undefined && lastItem.FY1BUD !== null) ? String(lastItem.FY1BUD) : '0';
        const fy1budDecimals = (fy1budStr.split('.')[1] || '').length;
        const roundedSum = Number(lastItem.SumMonthlyValues).toFixed(fy1budDecimals);
        return Number(roundedSum) === Number.parseFloat(fy1budStr);
    }

    private saveMonthlyItems() {
        if (!this.isMonthlyBudgetValid()) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Validation check: split by month budget must match with indicated yearly budget.' } });
            return;
        }
        const url = this.baseUrl + "api/KPIManagement/setopl/BUDM";
        this.http.post<any[]>(url, this.MlistComponent.updatedItems).subscribe({
            next: () => {
                this.loadInformation();
                this.toastrService.success('Kpi values were updated successfully!');
                this.isEditModeEnabled = false;
            },
            error: (error: any) => Utils.writeLog(this.http, this.baseUrl, error)
        });
    }

    isCorrectCurrencyValue(value: string, decimalDigits: number) {
        const dotIndex = value.indexOf('.');
        const colonIndex = value.indexOf(',');
        if (dotIndex === -1 && colonIndex === -1) {
            return true;
        }

        const maxSymbol = Math.max(dotIndex, colonIndex);
        if (maxSymbol === -1 || maxSymbol === value.length - 1) {
            return true;
        }
        return value.length - maxSymbol - 1 <= decimalDigits;
    }


    onClickReleaseMode(oplyearly: boolean) {
        let selectedRows = oplyearly ? this.OPLKPIYearlyMmgmtList?.getSelectionList() : this.OPLKPIMonthlyMmgmtList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Release Kpi values",
            message: `Do you want to release all current values for next fiscal year with selected parameters? Please note that you cannot edit any values after the release!.`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpReleaseKpiDefinitions(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , { isActual: false, oplyearly, isBranchReporting: this.isBranchReporting() }
                    , this
                    , function (tthis: OPLKPIManagementComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were released successfully!');
                        if (!tthis.hideSections())
                            oplyearly ? tthis.toggleRelease() : tthis.toggleMonthlyRelease();
                    }
                    , function (tthis: OPLKPIManagementComponent) {
                        tthis.toastrService.error('Kpi values could not be released. Please, contact with administrator');
                    }
                );
            }
        })
    }

    onClickRevoke(oplyearly: boolean) {
        let selectedRows = oplyearly ? this.OPLKPIYearlyMmgmtList?.getSelectionList() : this.OPLKPIMonthlyMmgmtList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Revoke KPI values",
            message: `Do you want to revoke all populated values for selected period?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpRevokeKpiValues(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , { isActual: false, oplyearly, isBranchReporting: this.isBranchReporting() }
                    , this
                    , function (tthis: OPLKPIManagementComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were revoked successfully!');
                        if (!tthis.hideSections())
                            oplyearly ? tthis.toggleRevoke() : tthis.toggleMonthlyRevoke();

                    }
                    , function (tthis: OPLKPIManagementComponent) {
                        tthis.toastrService.error('Kpi values could not be revoked. Please, contact with administrator');
                    }
                );
            }
        })
    }

    //Filter section

    auxFilterPredicate(filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean): boolean {
        if (filters === '__FORCE__') {
            return parentLevel || showAllEnabled || (Utils.IsValidNumber(data.FY1BUD) || Utils.IsValidNumber(data.FY2BUD) || Utils.IsValidNumber(data.FY3BUD) || Utils.IsValidNumber(data.YTDACT) || Utils.IsValidNumber(data.PYBUD) || Utils.IsValidNumber(data.FYFC));
        }
        const filterArray = filters.split('+').filter(Boolean);
        return filterArray.every(filter => {
            if (parentLevel) {
                const kpiname = (data.KpiName || '').toLowerCase();
                const id = (data.AccountID || '').toLowerCase();
                return kpiname.includes(filter.toLowerCase()) || id.includes(filter.toLowerCase());
            } else {
                const granularity = (data.Granularity || '').toLowerCase();
                let result = granularity.includes(filter.toLowerCase());
                if (!showAllEnabled) {
                    result = result && (Utils.IsValidNumber(data.FY1BUD) || Utils.IsValidNumber(data.FY2BUD) || Utils.IsValidNumber(data.FY3BUD) || Utils.IsValidNumber(data.YTDACT) || Utils.IsValidNumber(data.PYBUD) || Utils.IsValidNumber(data.FYFC));
                }
                return result;
            }
        });
    }

    private loadInformation(canShowReleaseMenssage: boolean = false) {
        this.subscriptions.forEach(x => x.unsubscribe())
        this.showReleaseLabel = false;
        this.showPrereleaseLabel = false;
        this.isAllLoaded = false
        this.updateTitle();


        if (this.hideSections())
            return;
        
        Utils.httpGetOPLYearlyReportingInformation(
            this.http
            , this.baseUrl
            , false
            , this
            , function (tthis: OPLKPIManagementComponent, result: KpiManagement[]) {
                result = result.filter(x => x.KpiDetail && x.KpiDetail.length > 0)
                result.forEach(x => {
                    const row = x.KpiDetail[0]
                    let maxBreakdown = ''
                    let yearlyColumns = Object.assign([], tthis.yearlyColumnsToDisplay);
                    let monthlyColumns = Object.assign([], tthis.monthlyColumnsToDisplay);

                    if (row.COL4 === '') {
                        yearlyColumns.splice(yearlyColumns.indexOf('COL4'), 1)
                        monthlyColumns.splice(monthlyColumns.indexOf('COL4'), 1)
                        maxBreakdown = 'COL3'
                    }
                    if (row.COL3 === '') {
                        yearlyColumns.splice(yearlyColumns.indexOf('COL3'), 1)
                        monthlyColumns.splice(monthlyColumns.indexOf('COL3'), 1)
                        maxBreakdown = 'COL2'
                    }
                    if (row.COL2 === '') {
                        yearlyColumns.splice(yearlyColumns.indexOf('COL2'), 1)
                        monthlyColumns.splice(monthlyColumns.indexOf('COL2'), 1)
                        maxBreakdown = 'COL1'
                    }
                    if (row.COL1 === '') {
                        yearlyColumns.splice(yearlyColumns.indexOf('COL1'), 1)
                        monthlyColumns.splice(monthlyColumns.indexOf('COL1'), 1)
                        maxBreakdown = 'COL0'
                    }
                    x.yearlyColumns = yearlyColumns
                    x.monthlyColumns = monthlyColumns
                    x.maxBreakdown = maxBreakdown
                    tthis.showReleaseLabel = tthis.showReleaseLabel || x.KpiDetail.some(x => x.ApprovalStatus === 'RELEASED' ||
                        x.ApprovalStatus_FY2 === 'RELEASED' ||
                        x.ApprovalStatus_FY3 === 'RELEASED')
                    tthis.showPrereleaseLabel = tthis.showPrereleaseLabel || x.KpiDetail.some(x => x.ApprovalStatus === 'PRE-RELEASED' ||
                        x.ApprovalStatus_FY2 === 'PRE-RELEASED' ||
                        x.ApprovalStatus_FY3 === 'PRE-RELEASED')

                });
                tthis.list = [];
                tthis.list = result;
                if ((!tthis.defaults.isYearlyOPLEnabled && tthis.router.url.includes('oplkpimanagement'))
                    && (!tthis.defaults.isYearlyOPLBranchReportingEnabled && tthis.router.url.includes('oplkpibranchreporting')))
                    tthis.selectedTabIndex = 1
                tthis.isAllLoaded = true;
            }
            , function (tthis: OPLKPIManagementComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
                tthis.list = [];
            }
        );
    }

    private getDatePrefix(): string {
        const date = new Date();
        const year = date.getFullYear().toString();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
    }

    downloadYearlyExcelInformation() {
        const datePrefix = this.getDatePrefix();
        Utils.httpDownloadYearlyOPLInformation(
            this.http
            , this.baseUrl
            , `${datePrefix}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 1}-${this.defaults.fiscalYear}_BUD_Y`
            , this.isShowAllEnabled
            , this.isBranchReporting()
            , this
            , function (tthis: OPLKPIManagementComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });
    }

    downloadMonthlyExcelInformation() {
        const datePrefix = this.getDatePrefix();
        Utils.httpDownloadMonthlyOPLInformation(
            this.http
            , this.baseUrl
            , `${datePrefix}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 1}-${this.defaults.fiscalYear}_BUD_M`
            , this.isShowAllEnabled
            , this.isBranchReporting()
            , false
            , this
            , function (tthis: OPLKPIManagementComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });
    }

    goUploadYearlyFileView() {
        if (this.isBranchReporting())
            this.router.navigate(["file/" + Utils.getFileUploadOplYearlyBranchReportingInformation()]);
        else
            this.router.navigate(["file/" + Utils.getFileUploadOplYearlyInformation()]);
    }

    goUploadMonthlyFileView() {
        if (this.isBranchReporting())
            this.router.navigate(["file/" + Utils.getFileUploadOplMonthlyBranchReportingInformation()]);
        else
            this.router.navigate(["file/" + Utils.getFileUploadOplMonthlyInformation()]);
    }

    private getDistinctAccountId(arr: KpiManagementUpdate[]): KpiManagementUpdate[] {
        return arr.filter((object, index, array) => {
            const firstOccurrenceIndex = array.findIndex((o) => o.AccountId === object.AccountId);
            return index === firstOccurrenceIndex;
        });
    }

    public toggleRelease() {
        this.isReleaseActive = !this.isReleaseActive;
        this.releaseButtonText = this.isReleaseActive ? 'Abort Release' : 'Initiate Release';
        this.OPLKPIYearlyMmgmtList.clearSelectionList();
    }

    public toggleRevoke() {
        this.isRevokeActive = !this.isRevokeActive;
        this.revokeButtonText = this.isRevokeActive ? 'Abort Revoke' : 'Initiate Revoke';
        this.OPLKPIYearlyMmgmtList.clearSelectionList();
    }

    public toggleMonthlyRelease() {
        this.isMonthlyReleaseActive = !this.isMonthlyReleaseActive;
        this.releaseMonthlyButtonText = this.isMonthlyReleaseActive ? 'Abort Release' : 'Initiate Release';
        this.OPLKPIMonthlyMmgmtList.clearSelectionList();
    }

    public toggleMonthlyRevoke() {
        this.isMonthlyRevokeActive = !this.isMonthlyRevokeActive;
        this.revokeMonthlyButtonText = this.isMonthlyRevokeActive ? 'Abort Revoke' : 'Initiate Revoke';
        this.OPLKPIMonthlyMmgmtList.clearSelectionList();
    }


    isBranchReporting() {
        const management = Utils.GetManagementChildrenByParent(this.defaults.managementids[0], this.defaults.managementid)
        return (this.router.url.toLowerCase() === '/oplkpibranchreporting' && (management?.BusinessLevel === 'MANAGEMENT' && management?.Groups?.length >= 1) || management?.BusinessLevel === 'FIELDBRANCH')
    }

    hideSections() {
        const management = Utils.GetManagementChildrenByParent(this.defaults.managementids[0], this.defaults.managementid)
        return (this.router.url.toLowerCase() === '/oplkpibranchreporting' && management?.BusinessLevel === 'MANAGEMENT' && management?.Groups?.length >= 1)
    }

    onBack() { }
}